export const AdRotationMode = {
	SEQUENTIAL: 'sequential',
	RANDOMIZED: 'randomized',
};
